import {
  AppBar,
  Box,
  IconButton,
  Container,
  Toolbar,
  Typography,
} from "@mui/material";
import { Link } from "react-router-dom";

import { ENV } from "../../utils/getEnv";

import MainMenu from "../MainMenu";

const styles = {
  toolbar: {
    "& a": {
      color: "white",
      textDecoration: "none",
    },
  },
  title: {
    flexGrow: 1,
    textAlign: "center",
  },
  main: {
    padding: "24px",
    paddingTop: "86px",
  },
  homeButton: {
    width: 48,
  },
};

const Desktop = ({ title = null, children }) => {
  return (
    <>
      <AppBar className="no-print">
        <Toolbar sx={styles.toolbar}>
          <IconButton href="/" sx={styles.homeButton}>
            <img src="/favicon192.png" alt="Home" width={24} />
          </IconButton>
          <Typography variant="h6" noWrap sx={styles.brand}>
            <Link to="/">{ENV.NAME}</Link>
          </Typography>
          <Typography variant="h6" sx={styles.title}>
            {title}
          </Typography>
          <MainMenu />
        </Toolbar>
      </AppBar>
      <Container>
        <Box sx={styles.main}>{children}</Box>
      </Container>
    </>
  );
};

export default Desktop;
